/*
  ShapeRenderer - Poprawiono obsługę parametrów Wymiary dla kształtów typu 'path'.
  Teraz ścieżki są skalowane proporcjonalnie do zadanych wymiarów w stosunku 
  do ich bazowych wymiarów z katalogu.
*/
import React from 'react';
import { getShapeById } from './shapeCatalog';

export class ShapeRenderer {
  constructor(ctx, scale = 1) {
    this.ctx = ctx;
    this.scale = scale;
  }

  renderItem(item, x, y, rotation = 0, isSelected = false, opacity = 1) {
    if (!item) return;

    this.ctx.save();
    this.ctx.translate(x, y);
    this.ctx.rotate(rotation);

    // ✅ Obsługa odbicia lustrzanego
    const flipScaleX = (item.flipX ? -1 : 1);
    const flipScaleY = (item.flipY ? -1 : 1);
    this.ctx.scale(flipScaleX, flipScaleY);

    if (isSelected) {
      this.ctx.shadowColor = '#1E2937';
      this.ctx.shadowBlur = 10;
    }

    this.ctx.globalAlpha = opacity;
    const { type, dimensions, render = {}, path, shapeId } = item;
    const itemRender = render || {};
    
    this.ctx.fillStyle = item.customFill || itemRender.fill || '#FFFFFF';
    this.ctx.strokeStyle = item.customStroke || itemRender.stroke || '#000000';
    this.ctx.lineWidth = (item.customStrokeWidth || itemRender.strokeWidth || 2) / this.scale;
    
    // Skalowanie ogólne (suwak skala)
    const s = item.scale || 1;
    this.ctx.scale(s, s);

    if (type === 'rect') {
      this.ctx.beginPath();
      this.ctx.rect(-dimensions.width / 2, -dimensions.height / 2, dimensions.width, dimensions.height);
      this.ctx.fill();
      this.ctx.stroke();
    } else if (type === 'circle') {
      this.ctx.beginPath();
      this.ctx.arc(0, 0, dimensions.width / 2, 0, Math.PI * 2);
      this.ctx.fill();
      this.ctx.stroke();
    } else if (type === 'ellipse') {
      this.ctx.beginPath();
      this.ctx.ellipse(0, 0, dimensions.width / 2, dimensions.height / 2, 0, 0, Math.PI * 2);
      this.ctx.fill();
      this.ctx.stroke();
    } else if (type === 'path' && path) {
      // ✅ FIX: Pobieramy bazowe wymiary z katalogu, aby obliczyć współczynnik skalowania dla ścieżki
      const template = getShapeById(shapeId);
      if (template && template.dimensions) {
        const scaleX = dimensions.width / template.dimensions.width;
        const scaleY = dimensions.height / template.dimensions.height;
        
        this.ctx.save();
        this.ctx.scale(scaleX, scaleY);
        this.renderPath(path, itemRender.fillRule || 'nonzero');
        this.ctx.restore();
      } else {
        // Fallback jeśli nie ma szablonu (używa surowej ścieżki)
        this.renderPath(path, itemRender.fillRule || 'nonzero');
      }
    }

    if (isSelected) {
      this.ctx.restore();
      this.ctx.save();
      this.ctx.translate(x, y);
      this.ctx.rotate(rotation);
      // Nie skalujemy ramki zaznaczenia przez flip, tylko przez scale
      this.ctx.scale(s, s);
      this.ctx.strokeStyle = '#1E2937';
      this.ctx.lineWidth = 2 / s / this.scale;
      this.ctx.setLineDash([5 / s / this.scale, 5 / s / this.scale]);
      const w = dimensions.width;
      const h = dimensions.height;
      this.ctx.strokeRect(-w/2 - 5, -h/2 - 5, w + 10, h + 10);
      this.ctx.restore();
    } else {
      this.ctx.restore();
    }
  }

  renderPath(pathString, fillRule = 'nonzero') {
    if (!pathString) return;
    
    // Using Path2D for full SVG path support (including arcs 'A') if available
    if (typeof Path2D !== 'undefined') {
        const p = new Path2D(pathString);
        this.ctx.fill(p, fillRule);
        this.ctx.stroke(p);
    } else {
        // Fallback for simple paths if Path2D is not available
        this.ctx.beginPath();
        const commands = pathString.match(/[MLZQHA][^MLZQHA]*/gi);
        if (commands) {
          commands.forEach(part => {
            const type = part[0].toUpperCase();
            const coords = part.slice(1).trim().split(/[\s,]+/).map(parseFloat);
            if (type === 'M') {
              this.ctx.moveTo(coords[0], coords[1]);
            } else if (type === 'L') {
              this.ctx.lineTo(coords[0], coords[1]);
            } else if (type === 'Q') {
              this.ctx.quadraticCurveTo(coords[0], coords[1], coords[2], coords[3]);
            } else if (type === 'C') {
              this.ctx.bezierCurveTo(coords[0], coords[1], coords[2], coords[3], coords[4], coords[5]);
            } else if (type === 'Z') {
              this.ctx.closePath();
            }
          });
        }
        this.ctx.fill(fillRule);
        this.ctx.stroke();
    }
  }
}

export default ShapeRenderer;